import React from 'react'
import Feedback from '../Components/Feedback'

const FeedbackPage: React.FC = () => {
  return <Feedback />
}

export default FeedbackPage
